module.exports = __webpack_public_path__ + "img/dotsleft.27b471a0.svg";